import { Button, SxProps, Theme } from '@mui/material';

interface IProps {
  name: 'submit' | 'reset' | 'button' | 'back' | 'next';
  onAction?: () => void;
  isDisabled?: boolean;
}


const CustomButton: React.FC<IProps> = ({ name, onAction, isDisabled }) => {
  // import helper lazily to avoid circular issues during tests
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  const { getButtonData: _getButtonData } = require('utils/button_utils');
  const data = _getButtonData(name, isDisabled);
  return (
    <Button
      sx={{ ...data.style }}
      type={data.type}
      onClick={onAction}
      disabled={isDisabled}
    >
      {data.text}
    </Button>
  );
};

export default CustomButton;
